import { getOrderDeliveryInterval } from '@/entities/order';
import type { DeliveryChunk, OrderDeliveryMethod } from '@/shared/api/order';
import { CheckoutCharacteristic } from '../CheckoutCharacteristic';

interface DeliveryIntervalProps {
    method: OrderDeliveryMethod;
    deliveryChunks: Array<DeliveryChunk>;
    chunkIndex: number;
}

export const DeliveryInterval = ({ method, deliveryChunks, chunkIndex }: DeliveryIntervalProps) => {
    const params = {
        method,
        deliveryChunks,
        chunkIndex,
    };

    switch (method) {
        case 'COURIER': {
            return <CheckoutCharacteristic title="Дата и время доставки" content={getOrderDeliveryInterval(params)} />;
        }
        case 'PICKUP_POINT': {
            return (
                <>
                    <CheckoutCharacteristic
                        title="Ожидаемая дата доставки"
                        content={getOrderDeliveryInterval(params, { showOnlyDate: true })}
                    />
                    <CheckoutCharacteristic title="Срок хранения" content="7 дней" />
                </>
            );
        }
        case 'SELF_PICK_UP': {
            return (
                <>
                    <CheckoutCharacteristic
                        title="Когда можно забирать"
                        content={getOrderDeliveryInterval(params, { showOnlyDate: true })}
                    />
                    <CheckoutCharacteristic title="Срок хранения" content="7 дней" />
                </>
            );
        }

        default: {
            return null;
        }
    }
};
